//
// Alternative Parts Carousel
//
// This carousel handles the display of the alternative parts in carousel form
// It manages state change between slides and adds / removes classes to dom
// elements to communicate these changes to CSS.
//
// This extends the Wallop package
// ---------------------------------------------------------------------------

'use strict';

import Wallop from '../vendor/wallop.js';

const config = {
    buttonPreviousClass: 'c-alt-part-carousel__link--prev',
    buttonNextClass: 'c-alt-part-carousel__link--next',
    listClass: 'c-alt-parts-carousel__body',
    itemClass: 'c-alt-parts-carousel__row',
    currentItemClass: 'c-alt-parts-carousel__row--current',
    showPreviousClass: 'c-alt-parts-carousel__row--showPrevious',
    showNextClass: 'c-alt-parts-carousel__row--showNext',
    hidePreviousClass: 'c-alt-parts-carousel__row--hidePrevious',
    hideNextClass: 'c-alt-parts-carousel__row--hideNext',
    carousel: false
};

export default class AlternativesCarousel extends Wallop {

    /**
     * @param {string} selector
     * @param {object} initPos
     */
    constructor(selector, initPos) {
        super(selector, config);

        this.loading = false;

        this.itemOffset = initPos.itemOffset;
        this.itemThisCount = initPos.itemThisCount;
        this.itemCount = initPos.itemCount;
    }

    /**
     * Reset all settings by removing classes and attributes added by
     * goTo() & updateButtonStates()
     */
    removeAllHelperSettings() {
        $(this.buttonPrevious).removeClass('is-invisible');
        $(this.buttonNext).removeClass('is-invisible');

        super.removeAllHelperSettings();
    }

    /**
     * Toggles is-invisible on the pagination buttons
     *
     * Overrides Wallop.updateButtonStates()
     */
    updateButtonStates() {
        if (this.isLastPage() && this.isLoadingNextPage()) {
            $(this.buttonNext).addClass('is-loading-page');
        }

        if (this.isLastSlide()) {
            $(this.buttonNext).addClass('is-invisible');
        }

        if (this.isFirstPage()) {
            $(this.buttonPrevious).addClass('is-invisible');
        }
    }

    /**
     * When pressing the back link we want to remove any loading state on
     * the next link
     */
    previous() {
        $(this.buttonNext).removeClass('is-loading-page');

        super.previous();
    }

    /**
     * Next page handler
     *
     * Loads the next page when the last page is reached and a new page
     * is requested by the user
     */
    next() {
        if (this.isLastPage() && !this.isLoadingNextPage()) {
            this.loading = true;
            $(this.buttonNext).addClass('is-loading-page');

            $.ajax({
                url: $(this.$selector).data('more-url'),
                method: 'GET',
                data: {
                    offset: (this.currentItemIndex + 1) * 3
                },
                dataType: 'html'
            }).done((response, textStatus, jqXHR) => {
                this.itemOffset = parseInt(jqXHR.getResponseHeader('X-Item-Offset'), 10) + 1;
                this.itemCount = parseInt(jqXHR.getResponseHeader('X-Item-Count'), 10);
                this.itemThisCount =
                    parseInt(jqXHR.getResponseHeader('X-Item-Offset'), 10) +
                    parseInt(jqXHR.getResponseHeader('X-Item-This-Count'), 10);

                $(' .' + this.options.listClass).append(response);
                if (this.isLastPage()) {
                    this.reset();
                    this.goTo(this.currentItemIndex + 1);
                } else {
                    this.reset();
                }
            }).fail(() => {
                $(this.buttonNext).addClass('is-invisible');
                return;
            }).always(() => {
                this.loading = false;
                $(this.buttonNext).removeClass('is-loading-page');
            });
        }

        // Only go to the next page if we aren't already on the last page and
        // we aren't trying to load a new page
        if ( !this.isLastPage() || !this.isLoadingNextPage()) {
            super.next();
        }
    }

    /**
     * Check to see if we are on the last available page
     *
     * @return {bool}
     */
    isLastPage() {
        return this.currentItemIndex === this.lastItemIndex;
    }

    /**
     * Check if we are on the last slide
     *
     * @return {bool}
     */
    isLastSlide() {
        return ((this.currentItemIndex + 1) * 3) >= this.itemCount;
    }

    /**
     * Check to see if an AJAX request is currently running
     *
     * @return {bool}
     */
    isLoadingNextPage() {
        return this.loading;
    }

    /**
     * Check to see if we are on the first page
     *
     * @return {bool}
     */
    isFirstPage() {
        return this.currentItemIndex === 0;
    }
}



// WEBPACK FOOTER //
// ./src/js/components/alternatives-carousel.js